import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-icon--sprite",
  "use": "close-icon--sprite-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"close-icon--sprite\"><path fill=\"currentColor\" d=\"m9 7.115 6.6-6.6L17.485 2.4l-6.6 6.6 6.6 6.6-1.885 1.885-6.6-6.6-6.6 6.6L.515 15.6l6.6-6.6-6.6-6.6L2.4.515z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol